import store from '@/store';
import i18n from '@/i18n';
import moment from 'moment-timezone';

export class Notification {
  validateBeforeRequest(data, languages) {
    if (!this.hasGermanTranslation(data.generalInformation.translations)) {
      this.showError('NOTIFICATIONS.ERROR_DE_TRANSLATION');
      return false;
    }

    let translationsParams = this.validateTranslations(
      data.generalInformation.translations,
      languages
    );
    if (translationsParams.status == 'negative') {
      this.showError(translationsParams.message);
      return false;
    }

    if (!this.canBuildDispatchTime(data.generalInformation)) {
      this.showError('NOTIFICATIONS.ERROR_DISPATCH_TIME');
      return false;
    }

    if (!this.hasFilter(data.filters)) {
      this.showError('NOTIFICATIONS.ERROR_FILTER');
      return false;
    }

    if (!this.hasRecipients(data.recipients)) {
      this.showError('NOTIFICATIONS.ERROR_RECIPIENTS');
      return false;
    }

    return true;
  }

  getClickabilitySave(data){
    if (!this.canBuildDispatchTime(data.generalInformation)) {
      return false;
    }

    if (!this.hasFilter(data.filters)) {
      return false;
    }

    if (!this.hasRecipients(data.recipients)) {
      return false;
    }

    return true;
  }

  hasGermanTranslation(data) {
    return data.deTitle && data.deMainInformation;
  }

  validateTranslations(data, languages) {
    let status = 'positive';
    let message = '';

    for (let language of languages) {
      if (
        !this.hasFullOrEmptyTranslation(
          data[language.locale + 'Title'],
          data[language.locale + 'MainInformation']
        )
      ) {
        status = 'negative';
        message =
          'NOTIFICATIONS.' +
          'ERROR_' +
          language.locale.toUpperCase() +
          '_TRANSLATION';
        break;
      }
    }

    return { status: status, message: message };
  }

  hasFullOrEmptyTranslation(title, description) {
    return (title && description) || (!title && !description) ? true : false;
  }

  canBuildDispatchTime(data) {
    return !data.chooseTime || data.dispatchTime;
  }

  hasFilter(data) {
    if (
      data !== null &&
      typeof data === 'object' &&
      Object.keys(data).length !== 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasRecipients(data) {
    return data && data.length ? true : false;
  }

  showError(data) {
    store.commit('snackbar/setSnack', {
      status: 'error',
      text: i18n.t(data)
    });
  }

  initFrontendNotification(data, languages) {
    let item = null;

    if (data) {
      item = {
        id: data.id,
        generalInformation: {
          image: data.image,
          file: null,
          dispatchTime: Notification.formatDate(data.dispatch_time),
          translations: this.getTranslationsObject(data.translations, languages)
        },
        filters: data.filter,
        recipients: data.users
      };
    } else {
      item = {
        generalInformation: {
          file: null,
          dispatchTime: null,
          translations: {}
        },
        filters: null,
        recipients: null
      };
    }

    return item;
  }

  static formatDate(data) {
    if (data) {
      return moment(data)
        .subtract(this.getTimezonesDiffInMinutes(), 'minute')
        .format('DD.MM.YYYY HH:mm');
    } else {
      return '-';
    }
  }

  static setTimeCenter(data) {
    return moment(data, 'DD.MM.YYYY HH:mm').add(
      Notification.getTimezonesDiffInMinutes(),
      'minute'
    );
  }

  getTranslationsObject(translationsArray, languages) {
    let translations = {};

    translationsArray.forEach(translation => {
      languages.forEach(language => {
        if (translation.language_id == language.id) {
          translations[language.locale + 'Id'] = translation.id;
          translations[language.locale + 'Title'] = translation.name;
          translations[language.locale + 'MainInformation'] =
            translation.description;
        }
      });
    });

    return translations;
  }

  static getTimezonesDiffInMinutes() {
    let nowLocal = moment().utcOffset();
    let nowCenter = moment()
      .tz('Europe/Zurich')
      .utcOffset();
    return nowCenter - nowLocal;
  }

  canBeUpdated(dispatchTimeServer) {
    return moment(dispatchTimeServer, 'YYYY-MM-DD HH:mm:ss', true)
      .subtract(Notification.getTimezonesDiffInMinutes(), 'minute')
      .diff(moment().add(store.state.notification.cronFrequency, 'minute')) > 0
      ? true
      : false;
  }
}
